import { FC, RefObject } from 'react';
import { useComponentModal } from 'src/hook/modal/useComponentModal';
import usePopUp from 'src/hook/modal/usePopUp';
import { AnimationType } from 'src/model/enum/enums';
import { Question } from 'src/model/Scenario';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './VideoSection.module.scss';

interface VideoSectionProps {
    videoUrl: string;
    videoRef: RefObject<HTMLVideoElement>;
    answer?: string;
    question: Question;
}

export const VideoSection: FC<VideoSectionProps> = ({ videoUrl, videoRef, answer, question }) => {
    const { startClosing, open } = useComponentModal();
    const { showClosePopUp } = usePopUp();


    const handleLoadedMetadata = () => {
        if (videoRef.current) {
            // Set time to 0.1 seconds to force thumbnail display
            videoRef.current.currentTime = 0.1;
        }
    };

    const handleVideoClick = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    };

    const handleClose = () => {
        if (answer)
            open('Answers', { question, answer }, AnimationType.SlideRight)
        else
            startClosing();
    };

    return (
        <div className={styles.videoContainer}>
            <span
                className={styles.close} onClick={() => showClosePopUp(handleClose)}>
                <img src={IconLocation('x')} alt="close" />
            </span>
            <video
                ref={videoRef}
                src={videoUrl}
                className={styles.video}
                playsInline
                preload="metadata"
                onLoadedMetadata={handleLoadedMetadata}
                onClick={handleVideoClick}
            />
        </div>
    );
}; 